import { ExpandMore } from "@mui/icons-material"
import { Accordion, AccordionDetails, AccordionSummary, Alert, Paper, Stack, Typography } from "@mui/material"
import { useFindShipmentInformation } from "../../api/DataReceiptApi"
import { useNexusDataReceiptIdOptional } from "../../hooks/useNexusParams"
import { useDataReceiptStore } from "../../zstore/DataReceiptStore"
import { SelectMissionFilters } from "./SelectMissionFilters"
import { SelectMissionsTable } from "./SelectMissionsTable"

export const SelectMissions = () => {
    const dataReceiptId = useNexusDataReceiptIdOptional()

    const page = useDataReceiptStore((state) => state.page)
    const pageSize = useDataReceiptStore((state) => state.pageSize)
    const order = useDataReceiptStore((state) => state.order)
    const orderBy = useDataReceiptStore((state) => state.orderBy)
    const filters = useDataReceiptStore((state) => state.filters)

    const shippingInfoResponse = useFindShipmentInformation({
        page,
        page_size: pageSize,
        order,
        ordering: orderBy,
        ...filters,
    })
    const shippingInfoData = shippingInfoResponse.data

    return (
        <Stack spacing={4} sx={{ pb: 2 }}>
            {shippingInfoResponse.isError && <Alert severity={"error"}>{shippingInfoResponse.error.message}</Alert>}
            <Accordion square={true} defaultExpanded={dataReceiptId == null}>
                <AccordionSummary expandIcon={<ExpandMore />} sx={{ flexDirection: "row-reverse", gap: 2 }}>
                    <Typography>Add Missions</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0 }}>
                    <Paper variant="outlined" sx={{ width: 1 }}>
                        {/* Filters */}
                        <SelectMissionFilters />

                        {/* Table */}
                        <SelectMissionsTable
                            totalShippingInfoCount={shippingInfoData?.count}
                            shippingInfo={shippingInfoData?.results}
                            isShippingInfoDataLoading={shippingInfoResponse.isFetching}
                        />
                    </Paper>
                </AccordionDetails>
            </Accordion>
        </Stack>
    )
}
